export default {
  design: 'Thiết kế sản phẩm',
  outlook: 'Ngoại hình sản phẩm',
  spec: 'Thông số kỹ thuật',

  product: {
    acces: [{ text: 'accesscontroller' }, { text: 'accessauto' }, { text: 'cloud' }],

    accesscontroller: {
      title: 'Access Controller',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, ABS/Gray, ABS/Black, PC/Translucent',
            },
            {
              title: 'Kích thước',
              description: '85.4mm x 85.4mm x 24.5mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Cortex M4 64MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '512KB, 64KB',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Kết nối',
              description: 'BLE 5.2',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Báo động',
              description: 'RGB LED x 4',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-10°C ~ +60°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: 'CR2477 1S 4P',
            },
          ],
        },
      ],
    },

    accessauto: {
      title: 'Access Auto',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, PC/Translucent Black',
            },
            {
              title: 'Kích thước',
              description: '210.1mm x 60.1mm x 42.2mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Dual-core 32bit LX6, 240MHz',
            },
            {
              title: 'Bộ nhớ',
              description: 'FLASH 8MB, PSRAM 2MB',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Kết nối',
              description: 'BLE 5.2, Wi-Fi 802.11b/g/n, 24GHz Microwave, SUB 1GHz',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Báo động',
              description: 'Door control, Shock detection, BEEP',
            },
            {
              title: 'Serial',
              description: 'RS232(USB Console)',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '0°C ~ +50°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: 'DC 12V, 24V (Không phân cực)',
            },
          ],
        },
      ],
    },

    cloud: {
      title: 'Cloud',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, PC/Translucent Black',
            },
            {
              title: 'Kích thước',
              description: '210.1mm x 60.1mm x 42.2mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Dual-core 32bit LX6, 240MHz',
            },
            {
              title: 'Bộ nhớ',
              description: 'FLASH 8MB, PSRAM 2MB',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Kết nối',
              description: 'BLE 5.2, Wi-Fi 802.11b/g/n, 24GHz Microwave, SUB 1GHz',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Báo động',
              description: 'Door control, Shock detection, BEEP',
            },
            {
              title: 'Serial',
              description: 'RS232(USB Console)',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '0°C ~ +50°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: 'DC 12V, 24V (Không phân cực)',
            },
          ],
        },
      ],
    },

    serverpcRTLS: {
      title: 'Server PC',
      spec: [
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Intel Xeon E-2334 (3.4Ghz 4Core 8M L3 65W)',
            },
            {
              title: 'Bộ nhớ',
              description: '16GB 3200MT/s DDR4 ECC UDIMM, tối đa 64GB, 4 khe',
            },
            {
              title: 'Kho lưu trữ',
              description: '1TB 7.2K RPM SATA 3.5"',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Bộ điều khiển mạng',
              description: 'Onboard Broadcom 5720, 2 cổng 1Gb LOM',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Trọng lượng',
              description: '12.2kg',
            },
            {
              title: 'Khe cắm mở rộng',
              description: '2 khe PCIe',
            },
            {
              title: 'Nguồn điện',
              description: 'Nguồn dự phòng kép (1+1), hot-plug, 600W',
            },
          ],
        },
      ],
    },

    serverpc: {
      title: 'Server PC',
      spec: [
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Intel Xeon Silver 4210R, 1 CPU, 10 Core',
            },
            {
              title: 'Bộ nhớ',
              description: '32GB',
            },
            {
              title: 'Kho lưu trữ',
              description: '1TB + 4TB',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Trọng lượng',
              description: '17.6kg',
            },
            {
              title: 'Khe cắm mở rộng',
              description: '16 khe PCI Gen3',
            },
            {
              title: 'Nguồn điện',
              description: '450W',
            },
          ],
        },
      ],
    },

    accesspro: {
      title: 'Access Pro',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'Aluminum/Gray, PC/Translucent',
            },
            {
              title: 'Kích thước',
              description: '256mm x 273mm x 24mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Khối lượng',
              description: '1.2Kg',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Quad-core A17 1.8GHz',
            },
            {
              title: 'Bộ nhớ',
              description: '2GB / 16GB',
            },
          ],
        },
        {
          name: 'Cảm biến và Camera',
          detail: [
            {
              title: 'Cảm biến hình ảnh',
              description: '1/3.06" CMO, MN34229',
            },
            {
              title: 'Loại ống kính',
              description: 'Fixed-focal',
            },
            {
              title: 'Góc nhìn camera',
              description: '180º',
            },
            {
              title: 'Độ phân giải',
              description: '1920 x 1080',
            },
          ],
        },
        {
          name: 'Màn hình hiển thị',
          detail: [
            {
              title: 'Độ phân giải',
              description: '10.1" TFT LCD 1280x800',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Âm thanh',
              description: 'MIC, Speaker',
            },
            {
              title: 'Thông báo',
              description: 'Door Control, Emergency Call',
            },
            {
              title: 'USB',
              description: 'USB2.0 Host x2, USB2.0 OTG x1',
            },
            {
              title: 'Serial',
              description: 'RS232(USB Console)',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '0°C ~ +40°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: 'ADAPTER 12V / 3A',
            },
          ],
        },
      ],
    },

    accesskey: {
      title: 'Access Key',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'Aluminum/Gray, PC/Translucent, ABS/White',
            },
            {
              title: 'Kích thước',
              description: '49mm x 26mm x 9mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Kết nối',
              description: '24GHz / Bluetooth 5.0',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Thông báo',
              description: 'LED(Status)',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '0°C ~ +40°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: '3.7V - 75mAh / Lithium Polymer',
            },
            {
              title: 'Định mức',
              description: '5V / 40mA',
            },
          ],
        },
      ],
    },

    emlock: {
      title: 'EM Lock',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'Aluminum/Gray',
            },
            {
              title: 'Kích thước',
              description: '178mm x 38mm x 25mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Chức năng và đặc điểm',
          detail: [
            {
              title: 'Lực giữ',
              description: '280KG/F',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-10°C ~ +55°C',
            },
            {
              title: 'Độ ẩm hoạt động',
              description: '0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: '12V/40mA',
            },
          ],
        },
      ],
    },

    deadbolt: {
      title: 'Deadbolt Lock',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'Aluminum/Gray',
            },
            {
              title: 'Kích thước',
              description: '203mm x 37mm x 41mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Khối lượng',
              description: '529g',
            },
          ],
        },
        {
          name: 'Chức năng nổi bật',
          detail: [
            {
              title: 'Ưu điểm nổi bật',
              description: 'Tích hợp điểm tiếp xúc mở riêng/ Hỗ trợ giám sát trạng thái khóa/ Có thể giám sát trạng thái cửa'
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-10°C ~ +55°C',
            },
            {
              title: 'Độ ẩm hoạt động',
              description: '0% ~ 90%',
            },
            {
              title: 'Dòng tiêu thụ',
              description: 'Hoạt động 900mA / Chờ 350mA',
            },
            {
              title: 'Nguồn điện',
              description: 'DC 12V',
            },
          ],
        },
      ],
    },

    autoDoorSensor: {
      title: 'Automatic Door Sensor',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, PC/Translucent Black',
            },
            {
              title: 'Kích thước',
              description: '210.1mm x 60.1mm x 42.2mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Dual-core 32bit LX6, 240MHz',
            },
            {
              title: 'Bộ nhớ',
              description: 'FLASH 8MB, PSRAM 2MB',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Kết nối',
              description: '24GHz Microwave, SUB 1GHz',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Báo động',
              description: 'Door control, Shock detection',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '0°C ~ +50°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: 'DC 12V, 24V (Không phân cực)',
            },
          ],
        },
      ],
    },

    twinTracker: {
      link: 'assetTagBle',
      title: 'TwinTracker',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, PC/Translucent White, Aluminum/Black',
            },
            {
              title: 'Kích thước',
              description: '95mm x 95mm x 32.5mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Dual-core 32bit LX6, 240MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '448KB ROM, 520 KB SRAM',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Ethernet',
              description: '100Base-TX',
            },
            {
              title: 'Không dây',
              description: 'BLE 5.2, Wi-Fi 802.11b/g/n',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Serial',
              description: 'RS232(USB Console)',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '0°C ~ +50°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: '3.2W, PoE 802.3af, USB 5V',
            },
          ],
        },
      ],
    },

    twinTrackerPro: {
      link: 'assetTagBle',
      title: 'TwinTracker Pro',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, PC/Translucent White, Aluminum/Black',
            },
            {
              title: 'Kích thước',
              description: '95mm x 95mm x 32.5mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Dual-core 32bit LX6, 240MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '448KB ROM, 520 KB SRAM',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Ethernet',
              description: '100Base-TX',
            },
            {
              title: 'Không dây',
              description: 'BLE 5.2, Wi-Fi 802.11b/g/n',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Serial',
              description: 'RS232(USB Console)',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-20°C ~ +50°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: '3.2W, PoE 802.3af, USB 5V',
            },
          ],
        },
      ],
    },

    assetTagBle: {
      title: 'Asset Tag (BLE)',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, ABS/Black, PC/Translucent',
            },
            {
              title: 'Kích thước',
              description: '48.4mm x 48.4mm x 10.7mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Khối lượng',
              description: '22g',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Cortex M4 64MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '512KB',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Không dây',
              description: 'BLE 5.2',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-20°C ~ +40°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: 'CR2450',
            },
          ],
        },
      ],
    },

    assetTag: {
      title: 'Asset Tag',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, ABS/Gray',
            },
            {
              title: 'Kích thước',
              description: '31mm x 31mm x 3.8mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Cortex M4 64MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '64KB',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Không dây',
              description: 'BLE 5.2',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-20°C ~ +40°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: 'CR2012',
            },
          ],
        },
      ],
    },

    tagUwb: {
      title: 'Tag (UWB)',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/Black',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Cortex M4 64MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '512KB',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Không dây',
              description: 'UWB 802.15.4',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-20°C ~ +50°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: 'USB-C',
            },
          ],
        },
      ],
    },

    safetyBell: {
      title: 'Safety Bell',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, ABS/Black, PC/Translucent White',
            },
            {
              title: 'Kích thước',
              description: '64.2mm x 64.2mm x 16.2mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'ARM Cortex M4, 64MHz',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Không dây',
              description: 'BLE 5.2, Wi-Fi 802.11b/g/n',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Âm thanh',
              description: 'Buzzer',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-20°C ~ +40°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: '2 x AAA',
            },
          ],
        },
      ],
    },

    smartSwitch: {
      title: 'Smart Switch',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, ABS/Black, Aluminum/Silver',
            },
            {
              title: 'Kích thước',
              description: '76mm x 120mm x 44.3mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'ARM® Cortex®-M4 32-Bit Processor with FPU, 64MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '215 EEMBC CoreMark® Score Running from Flash Memory',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Không dây',
              description: 'BLE 5.0, Wi-Fi 802.11 b/g/n',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Chạm',
              description: '',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '0°C ~ +60°C',
            },
          ],
        },
      ],
    },

    esl: {
      title: 'ESL',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, PC/Transparent',
            },
            {
              title: 'Kích thước',
              description: '76mm x 142mm x 10mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'ARM® Cortex®-M4 32-Bit Processor with FPU, 64MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '215 EEMBC CoreMark® Score Running from Flash Memory',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Không dây',
              description: 'BLE 5.0',
            },
          ],
        },
        {
          name: 'Màn hình hiển thị',
          detail: [
            {
              title: 'Độ phân giải',
              description: '800 x 600 (230 dpi)',
            },
            {
              title: 'Màu sắc',
              description: 'Black, White',
            },
            {
              title: 'Độ xám tối đa',
              description: '16',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Cổng kết nối',
              description: 'USB-C',
            },
            {
              title: 'Nguồn điện',
              description: '5V, 500mA',
            },
          ],
        },
      ],
    },

    mTag: {
      title: 'Mobile Tag',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, PC/Transparent',
            },
            {
              title: 'Kích thước',
              description: '38mm x 50.1mm x 18mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'ARM® Cortex®-M4 64MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '512KB',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Không dây',
              description: 'BLE 5.2',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Thông báo',
              description: 'LED(White) x1',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Cổng kết nối',
              description: 'Lightning, USB-C',
            },
            {
              title: 'Nguồn điện',
              description: 'Lithium Polymer Battery (4.2V, 35mAh)',
            },
          ],
        },
      ],
    },

    mCradle: {
      title: 'Mobile Cradle',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, PC/Transparent',
            },
            {
              title: 'Kích thước',
              description: '76mm x 40mm x 25mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'ARM® Cortex®-M4 64MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '512KB',
            },
            {
              title: 'Cảm biến',
              description: 'Cảm biến 3 trục',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Không dây',
              description: 'BLE 5.2',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Thông báo',
              description: 'LED(White) x1',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Nguồn điện',
              description: 'DC 5V (USB-C)',
            },
          ],
        },
      ],
    },

    idCard: {
      title: 'ID02',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, Aluminum',
            },
            {
              title: 'Kích thước',
              description: '51mm x 95.9mm x 7mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'ARM® Cortex®-M4 32-Bit Processor with FPU, 64MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '215 EEMBC CoreMark® Score Running from Flash Memory<br/>58 µA/MHz Running from Flash Memory<br/>51.6 µA/MHz Running from RAM',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Không dây',
              description: 'BLE 5.2',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Thông báo',
              description: 'LED(RGB) x1',
            },
            {
              title: 'USB',
              description: 'USB 2.0 Device x1',
            },
            {
              title: 'Nút nhấn',
              description: 'Slide Switch Button',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '0°C ~ 50°C',
            },
            {
              title: 'Nguồn điện',
              description: 'Lithium-polymer (3.7V / 300mA)',
            },
          ],
        },
      ],
    },

    ptz: {
      title: 'PTZ Camera',
      spec: [
        {
          name: 'Ngoại hình',
          detail: [
            {
              title: 'Kích thước',
              description: '266mm x 266mm x 410mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Camera',
          detail: [
            {
              title: 'Cảm biến hình ảnh',
              description: '1/1.8” CMOS quét tiến (Progressive Scan)',
            },
            {
              title: 'Zoom',
              description: '42× quang học, 16× số học',
            },
            {
              title: 'Độ phân giải',
              description: '2560 x 1440',
            },
          ],
        },
        {
          name: 'Ống kính',
          detail: [
            {
              title: 'Tiêu cự',
              description: '6.0mm – 252mm',
            },
            {
              title: 'Tốc độ zoom',
              description: '4.5 giây',
            },
            {
              title: 'Khẩu độ',
              description: 'F1.2',
            },
          ],
        },
        {
          name: 'PTZ',
          detail: [
            {
              title: 'Phạm vi Pan',
              description: '360°',
            },
            {
              title: 'Phạm vi Tilt',
              description: '-20° đến 90°',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Ethernet',
              description: '1 cổng RJ45 10/100M tự thích nghi, hỗ trợ Hi-PoE',
            },
            {
              title: 'Báo động',
              description: '7 đầu vào, 2 đầu ra',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Nguồn điện',
              description: '24VAC, PoE',
            },
            {
              title: 'Điều kiện hoạt động',
              description: '-40°C ~ +70°C, 0% ~ 95%',
            },
            {
              title: 'Chống nước/bụi',
              description: 'IP67',
            },
          ],
        },
      ],
    },

    ip: {
      title: 'IP Camera',
      spec: [
        {
          name: 'Ngoại hình',
          detail: [
            {
              title: 'Kích thước',
              description: '135mm x 135mm x 110mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Trọng lượng',
              description: 'Khoảng 800g',
            },
          ],
        },
        {
          name: 'Camera',
          detail: [
            {
              title: 'Cảm biến hình ảnh',
              description: '1/2.8" CMOS quét tiến',
            },
            {
              title: 'Độ phân giải',
              description: '1920 × 1080',
            },
          ],
        },
        {
          name: 'Ống kính',
          detail: [
            {
              title: 'Loại ống kính',
              description: 'Ống kính cố định, tùy chọn 2.8mm hoặc 4mm',
            },
            {
              title: 'Khẩu độ',
              description: 'F1.4',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Ethernet',
              description: '1 cổng RJ45 10/100M tự thích nghi',
            },
            {
              title: 'Báo động',
              description: '-S: 1 đầu vào, 1 đầu ra (tối đa 12 VDC, 30 mA)',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Nguồn điện',
              description: '12 VDC',
            },
            {
              title: 'Điều kiện hoạt động',
              description: '-30°C ~ +60°C, 0% ~ 95%',
            },
            {
              title: 'Chống nước/bụi',
              description: 'IP67',
            },
          ],
        },
      ],
    },

    nvr: {
      title: 'NVR',
      spec: [
        {
          name: 'Video & Audio',
          detail: [
            {
              title: 'Đầu vào video IP',
              description: '8 kênh',
            },
            {
              title: 'Chế độ xuất hình',
              description: 'HDMI/VGA xuất độc lập',
            },
            {
              title: 'Đầu ra HDMI',
              description: '4K (3840×2160)/30Hz, 2K (2560×1440)/60Hz, 1080p/60Hz, 1600×1200/60Hz, 1280×1024/60Hz, 1280×720/60Hz',
            },
            {
              title: 'Đầu ra VGA',
              description: '1920×1080/60Hz, 1280×1024/60Hz, 1280×720/60Hz',
            },
            {
              title: 'Đầu vào audio',
              description: '1 kênh, RCA (2.0 Vp-p, 1 KΩ)',
            },
            {
              title: 'Đầu ra audio',
              description: '1 kênh, RCA (tuyến tính, 1 KΩ)',
            },
          ],
        },
        {
          name: 'Giải mã',
          detail: [
            {
              title: 'Định dạng',
              description: 'H.265/H.265+/H.264/H.264+',
            },
            {
              title: 'Độ phân giải ghi',
              description: '12 MP/8 MP/6 MP/5 MP/4 MP/3 MP/1080p/UXGA/720p/VGA/4CIF/DCIF/2CIF/CIF/QCIF',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Phương thức truyền thông',
              description: 'TCP/IP, DHCP, IPv4, IPv6, DNS, DDNS, NTP, RTSP, SADP, SMTP, SNMP, NFS, iSCSI, ISUP, UPnP™, HTTP, HTTPS',
            },
            {
              title: 'Giao diện mạng',
              description: '1 cổng RJ-45 10/100/1000 Mbps tự thích nghi',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Nguồn điện',
              description: '12 VDC',
            },
            {
              title: 'Điều kiện hoạt động',
              description: '-10°C ~ +55°C, 10% ~ 90%',
            },
          ],
        },
      ],
    },

    loraGateway: {
      title: 'LoRA Gateway',
      spec: [
        {
          name: 'Thông số chung',
          detail: [
            {
              title: 'Chất liệu',
              description: 'Aluminum/Gray',
            },
            {
              title: 'Kích thước',
              description: '145mm x 145mm x 42mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Trọng lượng',
              description: '750g',
            },
            {
              title: 'Dải tần RF',
              description: '920.9MHz~923.1MHz BW 125KHz',
            },
            {
              title: 'Khoảng cách truyền thông truyền thông',
              description: 'Trong phạm vi 6km LOS(Line of Sight)',
            },
            {
              title: 'Độ nhạy anten',
              description: '-135 dBm',
            },
            {
              title: 'Công suất phát',
              description: '20 dBm',
            },
            {
              title: 'Bảo mật',
              description: 'AES-128',
            },
          ],
        },
        {
          name: 'Ethernet Gateway',
          detail: [
            {
              title: 'Thông số Ethernet',
              description: '10/100 Ethernet Controller',
            },
            {
              title: 'Chuẩn IEEE',
              description: '802.3',
            },
            {
              title: 'Chế độ hoạt động',
              description: 'Full-Duplex & Half-Duplex',
            },
            {
              title: 'Phương thức truyền thông hỗ trợ',
              description: 'DHCP, DNS, NTP, UDP, TCP, SNMP',
            },
            {
              title: 'Kết nối cáp',
              description: 'Ethernet',
            },
          ],
        },
        {
          name: 'Wi-Fi',
          detail: [
            {
              title: 'Chuẩn IEEE',
              description: '802.11b/g/n 2.4GHz',
            },
          ],
        },
        {
          name: 'Cellular LTE',
          detail: [
            {
              title: 'Loại LTE',
              description: 'LTE CatM1 (Telit ME910C1)',
            },
            {
              title: 'Kích thước SIM',
              description: 'Micro-SIM (3FF) 15×12×0.76mm',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-20°C ~ +60°C',
            },
            {
              title: 'Nguồn điện',
              description: 'DC 8 ~ 24V',
            },
            {
              title: 'Chứng nhận',
              description: 'KC, IP67',
            },
          ],
        },
      ],
    },

    loraSensor: {
      title: 'LoRA Sensor',
      spec: [
        {
          name: 'Thông số chung',
          detail: [
            {
              title: 'Chất liệu',
              description: 'Aluminum/Gray',
            },
            {
              title: 'Kích thước',
              description: '84mm x 72mm x 31mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Trọng lượng',
              description: '300g',
            },
            {
              title: 'Dải tần RF',
              description: '920.9MHz~923.1MHz BW 125KHz',
            },
            {
              title: 'Phương thức truyền thông',
              description: 'LoRA',
            },
            {
              title: 'Khoảng cách truyền thông truyền thông',
              description: 'Trong phạm vi 6km LOS(Line of Sight)',
            },
            {
              title: 'Bảo mật',
              description: 'AES-128',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-20°C ~ +60°C',
            },
            {
              title: 'Nguồn điện',
              description: 'DC 9V~33V<br/>Pin AA DC 3.6V / 2,500mAh x 2 (nối song song, tổng 5,000mAh)<br/>Pin AA DC 1.5V / 2,850mAh x 2 (nối tiếp, tổng 2,850mAh)',
            },
            {
              title: 'Chứng nhận',
              description: 'KC, IP67',
            },
          ],
        },
      ],
    },

    airQuality: {
      title: 'Air Quality Monitor',
      spec: [
        {
          name: 'Thông số chung',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White',
            },
            {
              title: 'Kích thước',
              description: '115mm x 115mm x 30mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Trọng lượng',
              description: '215g',
            },
            {
              title: 'Màn hình hiển thị',
              description: '2.0" TFT DISPLAY',
            },
            {
              title: 'Phương thức truyền thông',
              description: 'LoRA (tùy chọn), RS-485',
            },
          ],
        },
        {
          name: 'Phạm vi đo lường',
          detail: [
            {
              title: 'Bụi mịn',
              description: 'PM1.0/PM2.5/PM4.0/PM10: 0~1,000 µg/m³',
            },
            {
              title: 'Khí CO₂',
              description: '400~10,000 ppm',
            },
            {
              title: 'TVOC',
              description: '0~6,000 ppb',
            },
            {
              title: 'Khí nhà kính',
              description: '0~60,000 ppm',
            },
            {
              title: 'Nhiệt độ',
              description: '-40~125°C',
            },
            {
              title: 'Độ ẩm',
              description: '0~100% RH',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-20~60°C',
            },
            {
              title: 'Nguồn điện',
              description: 'DC 24V / 0.1A<br/>Li-polymer 1500mAh/3.7V',
            },
            {
              title: 'Chứng nhận',
              description: 'KC',
            },
          ],
        },
      ],
    },

    coMeasure: {
      title: 'CO Measure',
      spec: [
        {
          name: 'Thông số chung',
          detail: [
            {
              title: 'Chất liệu',
              description: 'Aluminum/Gray',
            },
            {
              title: 'Kích thước',
              description: '93mm x 125mm x 44mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Trọng lượng',
              description: '245g',
            },
            {
              title: 'Phương thức truyền thông',
              description: 'Wi-Fi (2.4GHz 802.11 b/g/n) & RS-485 (Modbus RTU)',
            },
          ],
        },
        {
          name: 'Phạm vi đo lường',
          detail: [
            {
              title: 'Bụi mịn',
              description: 'PM1.0/2.5/4.0/10: 0~1,000 µg/m³',
            },
            {
              title: 'CO',
              description: '0~100 ppm (nhiệt độ phòng)',
            },
            {
              title: 'Nhiệt độ',
              description: '-40~125°C',
            },
            {
              title: 'Độ ẩm',
              description: '0~100% RH',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-10~40°C',
            },
            {
              title: 'Nguồn điện',
              description: 'DC 24V / 0.1A',
            },
            {
              title: 'Chứng nhận',
              description: 'KC/CE/FCC',
            },
          ],
        },
      ],
    },

    plutoconPro: {
      title: 'Plutocon Pro',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, ABS/Gray, ABS/Black, PC/Translucent',
            },
            {
              title: 'Kích thước',
              description: '85.4mm x 85.4mm x 24.5mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Cortex M4 64MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '512KB, 64KB',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Kết nối',
              description: 'BLE 5.2',
            },
          ],
        },
        {
          name: 'Giao diện',
          detail: [
            {
              title: 'Báo động',
              description: 'RGB LED x 4',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-10°C ~ +60°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: 'CR2477 1S 4P',
            },
          ],
        },
      ],
    },

    orbroTag: {
      title: 'ORBRO Tag',
      spec: [
        {
          name: 'Thiết kế và chất liệu',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, ABS/Black, PC/Translucent',
            },
            {
              title: 'Kích thước',
              description: '48.4mm x 48.4mm x 10.7mm(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Trọng lượng',
              description: '22g',
            },
          ],
        },
        {
          name: 'Bộ xử lý và bộ nhớ',
          detail: [
            {
              title: 'Bộ vi xử lý',
              description: 'Cortex M4 64MHz',
            },
            {
              title: 'Bộ nhớ',
              description: '512KB',
            },
          ],
        },
        {
          name: 'Mạng',
          detail: [
            {
              title: 'Không dây',
              description: 'BLE 5.2',
            },
          ],
        },
        {
          name: 'Môi trường sử dụng và nguồn điện',
          detail: [
            {
              title: 'Điều kiện hoạt động',
              description: '-20°C ~ +40°C, 0% ~ 90%',
            },
            {
              title: 'Nguồn điện',
              description: 'CR2450',
            },
          ],
        },
      ],
    },

    deliveryRobot: {
      title: 'Delivery Robot',
      spec: [
        {
          name: '',
          detail: [
            {
              title: 'Chất liệu',
              description: 'ABS/White, PC/Translucent White, Aluminum/Black',
            },
            {
              title: 'Kích thước',
              description: '510 x 510 x 1300(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Dung tích chứa hàng',
              description: '20L',
            },
            {
              title: 'Môi trường di chuyển',
              description: 'Trong nhà',
            },
            {
              title: 'Góc dốc khi di chuyển',
              description: '+5°/-5°',
            },
            {
              title: 'Chiều cao gờ leo được',
              description: '1cm/-1cm',
            },
            {
              title: 'Độ chiếu sáng môi trường',
              description: '60~2000 lx (Min~Max)',
            },
          ],
        },
      ],
    },

    loadingKiosk: {
      title: 'Loa tích hợp tích hợpding Kiosk',
      spec: [
        {
          name: '',
          detail: [
            {
              title: 'Kích thước',
              description: '720 x 800 x 611(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Công suất xử lý',
              description: '20L/30L',
            },
            {
              title: 'Màn hình hiển thị',
              description: 'Màn hình hiển thị cảm ứng đa điểm 10.1"',
            },
            {
              title: 'Mạng',
              description: 'Ethernet (100Base-TX)/Wi-Fi',
            },
            {
              title: 'Nguồn điện',
              description: '100~240VAC/120W',
            },
          ],
        },
      ],
    },

    cobot: {
      title: 'Cobot',
      spec: [
        {
          name: '',
          detail: [
            {
              title: 'Kích thước',
              description: '220 x 227 x 1300(Chiều rộng x Chiều dài x Chiều cao)',
            },
            {
              title: 'Khoảng cách hoạt động tối đa ',
              description: '1300mm',
            },
            {
              title: 'Tải trọng tối đa',
              description: '12kg',
            },
            {
              title: 'Bậc tự do',
              description: '60 DoF',
            },
            {
              title: 'Mạng',
              description: 'Ethernet (100Base-TX)',
            },
            {
              title: 'Nguồn điện',
              description: '100~240VAC/1kW',
            },
          ],
        },
      ],
    },

    apart: {
      title: 'multi',
      list: [{ text: 'accesscontroller' }, { text: 'serverpc' }],
    },

    bleStarterKit: {
      title: 'multi',
      list: [{ text: 'twinTracker' }, { text: 'assetTagBle' }, { text: 'serverpcRTLS' }],
    },

    bleEnterpriseKit: {
      title: 'multi',
      list: [{ text: 'twinTracker' }, { text: 'assetTagBle' }, { text: 'serverpcRTLS' }],
    },

    workerTracking: {
      title: 'multi',
      list: [{ text: 'twinTrackerPro' }, { text: 'tagUwb' }, { text: 'serverpcRTLS' }],
    },

    cameraEnterpriseKit: {
      title: 'multi',
      list: [{ text: 'ptz' }, { text: 'nvr' }, { text: 'serverpc' }],
    },

    cameraStarterKit: {
      title: 'multi',
      list: [{ text: 'ip' }, { text: 'nvr' }, { text: 'serverpc' }],
    },

    robotBasic: {
      title: 'multi',
      list: [{ text: 'deliveryRobot' }, { text: 'twinTrackerPro' }, { text: 'tagUwb' }, { text: 'serverpc' }],
    },

    delivery: {
      title: 'multi',
      list: [{ text: 'deliveryRobot' }, { text: 'loadingKiosk' }, { text: 'cobot' }, { text: 'twinTrackerPro' }, { text: 'tagUwb' }, { text: 'serverpc' }],
    },

    disinfection: {
      title: 'multi',
      list: [{ text: 'deliveryRobot' }, { text: 'loadingKiosk' }, { text: 'cobot' }, { text: 'twinTrackerPro' }, { text: 'tagUwb' }, { text: 'serverpc' }],
    },
  },
};
